import React, { forwardRef, useMemo } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import BitSightMappingForm from "./BitSightMappingForm";

const BitSightCredentialsForm = forwardRef((props, ref) => {
  const fields = useMemo(
    () => [
      {
        name: "apiEndPoint",
        label: "API Endpoint",
        rules: [urlRegexValidator],
      },
      {
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
      },
    ],
    []
  );
  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={BitSightMappingForm}
      initialValue={{ apiEndPoint: 'https://service.bitsighttech.com' }}
    />
  );
});

export default BitSightCredentialsForm;
